import { render, staticRenderFns } from "./siderbarItem.vue?vue&type=template&id=c1e79b36&scoped=true&"
import script from "./siderbarItem.vue?vue&type=script&lang=js&"
export * from "./siderbarItem.vue?vue&type=script&lang=js&"
import style0 from "./siderbarItem.vue?vue&type=style&index=0&id=c1e79b36&scoped=true&lang=css&"
import style1 from "./siderbarItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e79b36",
  null
  
)

export default component.exports